import React from "react";
import { Helmet } from "react-helmet-async";
import "../styles/consulting.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Landing from "../components/Landing";
import PayrollCard from "../components/PayrollCard";
import { PAYROLL_OPTION, PAYROLL_BANNERS, CLIENTS } from "../constant";
import Cards from "../components/Cards";
import Partners from "../components/Partners";
import payrollImg from "../assests/images/what-is-hr.webp";
import { canonicalFor, PAGE_META } from "../config/site";

const meta = PAGE_META["/payroll"];

function PayrollPage() {
  return (
    <React.Fragment>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <link rel="canonical" href={canonicalFor("/payroll")} />
      </Helmet>

      <div className="layout">
        <Navbar />
        <Landing
          title="Your Business"
          subtitle="Our Solutions."
          content="Our experienced team handles every aspect of payroll — calculating wages and deductions, generating pay stubs and tax forms — so your employees are paid accurately and on time, every time."
          label="Contact Us"
          trigger={true}
          src={payrollImg}
          id="payroll-hero"
        />
      </div>
      <section className="payroll-services">
        <h1 style={{ marginBottom: "-20px" }}>Our Services</h1>
        <div className="card-container">
          {PAYROLL_OPTION.map((item, idx) => (
            <PayrollCard
              key={idx}
              payroll={item.payroll}
              desc={item.desc}
              img={item.src}
            />
          ))}
        </div>
        <Cards
          title="Benefits of Cloudare Payroll Services"
          section={PAYROLL_BANNERS}
          id={1}
        />
      </section>
      <Partners
        list={CLIENTS}
        title="Enterprises and startups choose Cloudare to scale their teams"
      />
      <Footer />
    </React.Fragment>
  );
}

export default PayrollPage;
